/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */
import React from "react";
import { Link } from "react-router-dom";
import { RichTextSimple } from "@simplicitycms/simplicity-richtext";

const HeroSlideWithForegroundMobile = (props) => {

    const foregroundImageSrc = props?.foregroundImageSrc ?? "";
    const foregroundImageAlt = props?.foregroundImageAlt ?? "";
    const title = props?.title ?? "";
    const subtitle = props?.subtitle ?? "";
    const description = props?.description ?? "";
    const linkText = props?.linkText ?? "";
    const scrollToSection = props?.scrollToSection;

    return (
        <div className='hero-content foreground-mobile'>
            <h1>
                {title}
                {subtitle && <span>{` ${subtitle}`}</span>}
            </h1>

            <img src={foregroundImageSrc} alt={foregroundImageAlt} />

            <RichTextSimple
                richtext={description}
                className='hero-slide-description'
            />

            <Link onClick={scrollToSection} className='hero-slide-link'>
                {linkText}
            </Link>
        </div>

    );
};

export { HeroSlideWithForegroundMobile };
